<template>
  <main class="dashboard" v-loading="false">
    <!-- //START of top search section -->
    <div class="flex items-center py-3 flex-wrap">
      <div class="md:w-6/12 w-full mt-2">
        <h2 class="dashboard-header">Dashboard Overview</h2>
        <span>{{ currentDate }}</span>
      </div>
      <div v-if="dateFilter == 'custom'" class="md:w-6/12 w-full flex justify-end mt-2">
        <el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3" v-model="startDate" />
        <el-date-picker type="date" placeholder="End Date" style="margin: 0" class="mr-3" v-model="endDate" />
        <primary-button class="shadow-md font-normal hidden" buttonText="Search" :loading="isLoading"
          @click="getOverview" />

      </div>
    </div>
    
    <!-- //End of top search section -->

    <section class="mt-12 shadow-md rounded-xl">
      <div v-loading="isLoading">
        <div class="flex justify-end w-full px-4 pt-4"></div>
        <div class="flex items-center px-4 py-4 flex-wrap item">
          <div class="w-6/12 font-bold">My Shipments Metric</div>

          <div class="w-6/12 justify-end flex ">
            <div>
              <el-dropdown trigger="click" class="h-full w_semi">
                <div class="drp-content">
                  <span>

                    <img src="../../../views/3pl/BillingandCollection/icons/CalendarIcon.svg" />
                    <abbr class="vrt_line"></abbr>
                    <span class="inline-block whitespace-nowrap">{{ filterTitle }}</span>
                  </span>
                  <ArrowDownBlackIcon :style="{ width: '13px' }" color="black" />
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <button @click="setFilterType('today', 'Today')">Today</button>
                  </el-dropdown-item>

                  <el-dropdown-item>
                    <button @click="setFilterType('weekly', 'This Week')">This week</button>
                  </el-dropdown-item>

                  <el-dropdown-item>
                    <button @click="setFilterType('monthly', 'This Month')">This month</button>
                  </el-dropdown-item>

                  <el-dropdown-item>
                    <button @click="setFilterType('yearly', 'This Year')">This year</button>
                  </el-dropdown-item>

                   <el-dropdown-item>
                    <button @click="setFilterType('all', 'All time')">All Time</button>
                  </el-dropdown-item>

                  <el-dropdown-item>
                    <button @click="setFilterType('custom', 'Custom')">Custom</button>
                  </el-dropdown-item>

                  <!-- <el-dropdown-item>
                    <button @click="setFilterType('30day', '30 Day')">30 Day</button>
                  </el-dropdown-item> -->

                  <!-- <el-dropdown-item>
                    <button @click="setFilterType('60day', '60 day')">60 Day</button>
                  </el-dropdown-item> -->
                 
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <SMChart :deliverySent="deliverySent" />
      </div>

      <div id="content">
        <div v-for="(chartData, index) in filteredCharts" :key="index"
          :class="{ 'Recent-Shipments': index === 0, 'Top-Destinations': index === 1, 'Top-Providers': index === 2 }">
          <Tops :showLabels="chartData.showLabels" :fontSize="chartData.fontSize" :keys="chartsData[index].id"
            :showTotal="chartData.showTotal" :totalLabel="chartData.totalLabel" :header="chartData.header"
            :colors="chartData.colors" :labels="chartData.labels" :series="chartData.series" />
        </div>
      </div>

      <SSChart :shippingSpend="shippingSpend" />
    </section>
  </main>
</template>

<script>
import SMChart from "./modules/ShipmentMetric.vue"
import SSChart from "./modules/ShippingSpend.vue"
import Tops from "./modules/Tops.vue"
import debounce from "@/utilities/debounce";
import moment from "moment";

export default {
  components: {
    SMChart,
    SSChart,
    Tops,
  },
  data() {
    return {
      filterTitle: 'This Month',
      startDate: "",
      endDate: "",
      dateFilter: "monthly",
      analyticData: {},
      recenShippment: [],
      topProvider: [],
      topDestination: [],
      shippingSpend: [],
      shippmentMetric: {},
      deliverySent: [],
      isLoading: false,
      chartsData: [
        {
          series: [0],
          labels: [''],
          colors: [],
          header: 'Recent Shipments',
          totalLabel: ['no data available'],
          showTotal: 'null',
          showLabels: true,
          fontSize: "14px",
          id: 0,
        },
        {
          series: [0],
          labels: [''],
          colors: [''],
          header: 'Top Destinations',
          totalLabel: ['no data available'],
          showTotal: '',
          showLabels: true,
          id: 1,
        },
        {
          series: [0],
          labels: [''],
          colors: [''],
          header: 'Top Providers',
          totalLabel: ['no data available'],
          showTotal: '',
          showLabels: true,
          id: 2,
        }

      ]
    };
  },

  watch: {
    "sortProps": debounce(function () {
      if (this.dateFilter == 'custom' && this.startDate && this.endDate && (this.endDate > this.startDate)) {
        this.payload.startDate = this.sortProps.startDate;
        this.payload.endDate = this.sortProps.endDate
        this.getOverview();

      }
    }, 500),
  },

  computed: {
    filteredCharts() {
      // development mode: show all charts
      return this.chartsData;
    },
    sortProps() {
      return {
        dateFilter: this.dateFilter,
        startDate: this.startDate ? moment(this.startDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        endDate: this.endDate ? moment(this.endDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
      };
    },
    currentDate() {
      return moment().format("Do MMMM, YYYY");
    },
    userId() {
      return localStorage.getItem("userId");
    },

    payload() {
      return {
        userId: this.userId,
        dateFilter: this.sortProps.dateFilter,
        startDate: "",
        // startDate: "2025-02-26",
        // endDate: "2025-02-26"
        endDate: ""
      };
    },
  },

  mounted() {
    this.getOverview();
  },

  methods: {
    resetChart(index) {
    
      this.chartsData[index] = {
        ...this.chartsData[index],
        series: [],
        labels: [],
        colors: [],
        totalLabel: []
      };
    },
    setFilterType(val, title) {
      this.dateFilter = null
      this.dateFilter = val
      this.filterTitle = title
      if (this.dateFilter != "custom") {
        this.getOverview();
        this.startDate = ""
        this.endDate = ""
      }
      // if (this.dateFilter === "all") {
      //   this.payload.startDate = "2024-01-01";
      //   this.payload.endDate = this.endDate ? moment(this.endDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
      //     this.getOverview();
      // }
    },
    async getOverview() {
      this.isLoading = true;
      try {
        const response = await this.$_getAllOverview(this.payload);
        this.analyticData = response.data;
        const recenShippment  = this.analyticData.recenShippment
        const topDestination  = this.analyticData.topDestination
        const topProvider  = this.analyticData.topProvider
        


        this.loadShippmentMetric();
        this.loadShippingSpend();
        this.loadTopProvider(topProvider);
        this.loadTopDestination(topDestination);
        this.loadRecentShippment(recenShippment);


      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },

    loadShippmentMetric() {
      this.shippmentMetric = this.analyticData.shipmentMetric
      const deliverySent = this.shippmentMetric.deliverySent
      this.deliverySent = deliverySent
    },
    loadShippingSpend() {
      this.shippingSpend = this.analyticData.shippingSpend
    },
  
    loadTopProvider(val) {
      this.resetChart(2); // clear chart before loading new data
      this.topProvider = val || [];

      // Filter and process only valid data
      const validProviders = this.topProvider
        .filter(item => item.count && !isNaN(item.count)) // Ensure count is numeric
        .map(item => ({
          companyname: item.companyname || 'N/A', // fallback for null names
          count: Number(item.count),
          orgId: item.orgId
        }));

      // If no valid providers, keep chart empty
      if (validProviders.length === 0) {
        this.chartsData[2].series = [0];
        this.chartsData[2].labels = ['No Data'];
        this.chartsData[2].totalLabel = ['No Providers Found'];
        this.chartsData[2].colors = ['#A5ADB7'];
        
        return;
      }

      // Limit to top 5 providers by count
      const topProviders = validProviders
        .sort((a, b) => b.count - a.count)
        .slice(0, 5);

      // Update chart series and labels
      this.chartsData[2].series = topProviders.map(p => p.count);
      this.chartsData[2].labels = topProviders.map(p => p.companyname);

      // Update chart colors and total label
      this.chartsData[2].colors = ['#09B78A', '#FFA600', '#383F51', '#FE4D3C', '#A5ADB7'];
      this.chartsData[2].totalLabel = ['Top Providers'];
    },



    loadTopDestination(val) {
      this.topDestination = val;
      const topFiveCounts = this.topDestination.slice(0, 5);

      // Reset this specific chart data
      this.resetChart(1);

      if (topFiveCounts.length === 0) {
     
        return;
      }

      const counts = topFiveCounts.map(destination => parseInt(destination.total_count));
      const states = topFiveCounts.map(destination => destination.state || 'NULL');

      this.chartsData[1].series = counts;
      this.chartsData[1].labels = states;
      this.chartsData[1].totalLabel = ['Top 5 States'];
      this.chartsData[1].colors = ['#FFA600', '#D72638', '#7A90A7', '#09B78A', 'blue'];

      // Optional cleanup if your chart structure needs it
      this.remove2LastItem();
    },

    loadRecentShippment(val) {
      // Normalise input
      const recent = Array.isArray(val) ? val : (this.analyticData?.recenShippment || []);
      // Fully reset the chart slot first
      this.resetChart(0);

      // If no data, set a friendly fallback and return
      if (!recent.length) {
        this.chartsData[0] = {
          ...this.chartsData[0],
          series: [0],
          labels: ['No data'],
          // colors: ['#E5E7EB'],
          colors: [''],
          totalLabel: ['no data available']
        };
        // Ensure Vue detects the change (for Vue2 compatibility)
        this.chartsData = this.chartsData.slice();
        return;
      }

      // Build arrays
      const counts = recent.map(item => Number(item.total_count) || 0);
      const totalCount = counts.reduce((s, n) => s + n, 0) || 1; // avoid divide by zero

      // If you want percentages in label, format them here. Otherwise just use status names:
      const labels = recent.map(item => {
        const status = (item.deliveryStatus || '').toString();
        // example with percentage:
        const pct = ((Number(item.total_count) / totalCount) * 100).toFixed(2);
        return `${status.charAt(0).toUpperCase() + status.slice(1)}: ${pct}%`;
        // OR return status only:
        // return status.charAt(0).toUpperCase() + status.slice(1);
      });

      // Choose colors length-matched to counts
      const baseColors = ['#D72638', '#09B78A', '#FFA600', '#7A90A7'];
      const usedColors = baseColors.slice(0, counts.length);

      // Replace the chart data (not push)
      const updatedChart = {
        ...this.chartsData[0],
        series: counts,
        labels: labels,
        colors: usedColors,
        totalLabel: ['Shipments']
      };

      // Replace the item so Vue reactivity triggers
      this.chartsData.splice(0, 1, updatedChart);
      // Also reassign the outer array to be safe in some cases:
      this.chartsData = this.chartsData.slice();

      // debug
      
    },

    removeLastItem(i) {
      this.chartsData[i].totalLabel.pop();
      this.chartsData[i].colors.pop();
    },
    remove2LastItem() {
      // this.chartsData[1].totalLabel.pop();
      // this.chartsData[1].colors.pop();
    },
    remove3LastItem() {
      this.chartsData[2].totalLabel.pop();
      this.chartsData[2].colors.pop();
    },

  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1100px) {
  #content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
    width: 97%;
    grid-template-areas:
      "RS TD"
      "TP TP";
  }
}

#content>* {
  border: 2px solid transparent;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 2px #00000014;
  margin: 0;
}

#content .Top-Providers {
  width: 50%;
  margin: 0 auto;
}

.Recent-Shipments {
  grid-area: RS;
}

.Top-Destinations {
  grid-area: TD;
}

.Top-Providers {
  grid-area: TP;
}

@media (max-width: 1100px) {
  #content .Top-Providers {
    width: 100%;
    margin: 0;
  }
}

section {
  @apply border-transparent border-solid border-2 shadow-xl;
}

.dashboard-header {
  @apply py-2;
  font-size: 24px;
}

.dashboard {
  @apply bg-white p-4 pb-24;
}

.MD-section {
  @apply w-full text-center bg-primary-navy text-white py-6 border-r-2 border-gray-500;
}

.IC-section {
  @apply w-full text-center;
}

.turn-up {
  transform: rotateZ(180deg);
}

.turn-off {
  transform: rotateZ(0deg);
}

.w_semi {
  @apply w-[200px] flex items-center
}

.drp-content {
  @apply w-full border-[1px] h-full py-[8px] rounded flex items-center justify-between px-2;

  span {
    @apply flex items-center
  }
}

.vrt_line {
  @apply w-[1px] h-[17px] bg-gray-400 inline-block mx-2
}
</style>
